"use client";

import { useContext, useEffect } from "react";

import { UserContext } from "@/context/UserContext";

interface Props {
  slug: string;
  inventoryAvailable: boolean;
}

export default function InventoryAvailabilityStorage({ slug, inventoryAvailable }: Props) {
  const { setIsInventoryAvailable } = useContext(UserContext);

  useEffect(() => {
    setIsInventoryAvailable && setIsInventoryAvailable({ slug, available: inventoryAvailable });
  }, [slug, inventoryAvailable]);

  return null;
}
